<template lang="pug">
  el-card.box(shadow="hover")
    app-modal-gerenciamento-modulos(
      v-if="showModal"
      :moduloParaEditar="moduloParaEditar"
      @closeModal="closeModal"
      @adicionar="adicionar"
      @atualizarModulo="atualizarModulo"
      )
    h1 Modulos
    div.containerBotao
      span Módulos / serviços existentes
      el-button.botaoAdd(type="primary", icon="el-icon-plus", id='botao-add', @click="abrirModal") Cadastrar
    div.modulosContainer
      div.modulo(v-for="modulo in modulos" :key="modulo.id")
            el-row(type="flex", justify="space-between").nomeModuloContainer
              span.titulo
                i.fa.fa-circle(:style="{'margin-right': '10px', 'font-size': '22px', 'color': modulo.status === 'OK' ? 'rgb(86, 242, 86)' : modulo.status === 'DESLIGADO' ? 'rgb(254, 49, 49)' : 'rgba(0, 0, 0, 0.10)'}")
                h3 {{ encurtarString( modulo.nome.length, 39,  modulo.nome) }}
              el-dropdown(trigger="click")
                el-col(:span="2")
                  i.fa.fa-ellipsis-v(:style="{'font-size': '22px','cursor': 'pointer'}")
                  template#dropdown
                    el-dropdown-menu
                      el-dropdown-item(v-if="modulo.status === 'DESLIGADO'")
                        span(@click="executarComandoModulo(modulo.id, 'LIGAR')").moduloAcao
                          i.far.fa-power-off(:style="{'font-size': '20px', 'margin-right': '8px'}")
                          p Ativar
                      el-dropdown-item(v-else)
                        span(@click="executarComandoModulo(modulo.id, 'DESLIGAR')").moduloAcao
                          i.fa.fa-power-off(:style="{'font-size': '20px', 'margin-right': '8px'}")
                          p Desativar
                      el-dropdown-item
                        span(@click="executarComandoModulo(modulo.id, 'REINICIAR')").moduloAcao
                          img(:src="icone", alt="icone de reiniciar", :style="{'font-size': '20px', 'margin-right': '8px'}")
                          p Reiniciar
            .linha
            span.vistoPorUltimo
              p
                i Visto por ultimo: {{  modulo.vistoPorUltimo}}
            div.infoModulos
              p
                strong.dado Nome servico:
                span {{ encurtarString( modulo.nomeDoServico.length, 33,  modulo.nomeDoServico) }}
              p
                strong.dado Ip:
                span {{ modulo.ip}}
              p
                strong.dado Porta:
                span {{  encurtarString( modulo.porta.length, 30,  modulo.porta) }}
              p
                strong.dado Status:
                span {{ modulo.statusFormatado }}
            el-row(type="flex", justify="space-between")
              el-button.botao(@click="deletarModulo(modulo.id)") Remover
              el-button.botao(@click="editarModulo(modulo)") Editar
</template>

<script>
import AppModalGerenciamentoModulos from './components/modal/AppModalGerenciamentoModulos.vue'
import { salvarModulo, buscarModulos } from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import { deletarModulosPorId, editaModulo, executarComando } from '../../utils/manutencao'
import iconeArrowCircle from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/circle-arrow-out-up-left.svg'
export default {
  data () {
    return {
      showModal: false,
      modulos: [],
      moduloParaEditar: null,
      icone: iconeArrowCircle
    }
  },
  async created () {
    this.buscarTodosModulos()
    setInterval(this.buscarTodosModulos, 30000)
  },
  mixins: [
    AppNotificacao
  ],
  components: {
    AppModalGerenciamentoModulos
  },
  methods: {
    closeModal () {
      this.showModal = false
    },
    async buscarTodosModulos () {
      try {
        const resposta = await buscarModulos()
        this.modulos = resposta
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro')
      }
    },
    async adicionar (moduloAdd) {
      try {
        await salvarModulo(moduloAdd)
        this.showModal = false
        this.buscarTodosModulos()
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Modulo salvo')
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'nao tem galamtia')
      }
    },
    abrirModal () {
      this.showModal = true
      this.moduloParaEditar = null
    },
    async deletarModulo (id) {
      this.confirmBox(this.$messages.APAGAR_MODULO, this.$messages.TITULO_WARNING,
        async () => {
          try {
            await deletarModulosPorId(id)
            this.buscarTodosModulos()
          } catch (e) {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao deletar modulo')
          }
        }
      )
    },
    editarModulo (modulo) {
      this.showModal = true
      this.moduloParaEditar = modulo
    },
    async atualizarModulo (modulo) {
      try {
        await editaModulo(modulo.idModulo, modulo.dadosParaAtualizacao)
        this.showModal = false
        this.buscarTodosModulos()
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Ero ao atualizar processo')
        this.showModal = false
      }
    },
    encurtarString (tamanho, limite, texto) {
      return tamanho >= limite ? texto.substring(0, limite) + '...' : texto
    },
    async executarComandoModulo (id, acao) {
      try {
        await executarComando(id, acao)
        this.buscarTodosModulos()
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Ocorreu um erro ao execusar a ação', acao)
      }
    }
  }
}
</script>

<style scoped>
  .box {
    min-width: 700px;
    padding-left: 3px;
    padding-right: 3px;
  }
  .nomeModuloContainer {
    height: 35px;
    align-items: center;
  }
  .infoModulos {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 150px;
    margin-top: 20px;
  }
  .botao {
    width: 120px;
    height: 40px;
    font-size: 15px;
  }
  .botaoModulo {
    display: flex;
    justify-content: space-between;
  }
  .botaoAdd {
    font-size: 18px;
    align-items: end;
  }
  .containerBotao {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
  }
  .modulosContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    align-items: center;
  }
  .modulo {
    border: 1px solid rgba(0, 0, 0, 0.10);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
    border-radius: 5px;
    width: 380px;
    height: 320px;
    padding: 10px;
    margin: 0px 60px 60px 0px;
  }
   .vistoPorUltimo {
    text-align: end;
    font-size: 10px
  }
  p {
    font-size: 15px ;
    margin-right: 1px;
  }

  .dado {
    margin-right: 5px;
  }

  .titulo {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
  }
  .moduloAcao {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 32px;
    width: 110px;
    margin: 0;
  }
  .linha {
    background-color: rgba(0, 0, 0, 0.10);
    margin-top: 10px;
    margin-bottom: 2px;
    width: 100%;
    height: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/GerenciarModulos.vue